<div class="w-96 h-full pb-5 pe-5">
    <div class="flex h-full">
        <p-divider type="solid" layout="vertical" styleClass="border-2" />
        <div class="w-full">
            <app-sidebar-user-info />
        </div>  
        <p-divider type="solid" layout="vertical" styleClass="border-2" />  
    </div>
</div>

